<div class="card">
  <div class="card-header">
    <img
      class="header-image"
      [alt]="reward().label"
      [src]="reward().bannerLink"
    />
  </div>

  <div class="card-footer">
    @if (reward().isActive) {
      @let selectionButtonConfig = config().selectionButton.states.active;
      <button
        type="button"
        (click)="onSelectReward()"
        class="btn selection-button"
        [title]="selectionButtonConfig.label"
        [style.color]="selectionButtonConfig.color"
        [style.border]="selectionButtonConfig.border"
        [style.fontFamily]="selectionButtonConfig.fontFamily"
        [style.backgroundColor]="selectionButtonConfig.backgroundColor"
        [style.borderRadius]="config().selectionButton.states.borderRadius"
      >
        {{ config().selectionButton.states.active.label }}
      </button>
      <b2c-button
        type="button"
        class="btn-tc"
        data-cy="tc_btn"
        (click)="showTermsAndConditions()"
        [title]="config().termsAndConditionsButton.label"
        [styles]="{
          border: 'none',
          fontSize: '14px',
          borderRadius: '0',
          backgroundColor: 'transparent',
          color: config().termsAndConditionsButton.color,
          fontFamily: config().termsAndConditionsButton.fontFamily,
        }"
      >
        <span class="label">{{ config().termsAndConditionsButton.label }}</span>
      </b2c-button>
    } @else {
      @let hasEnoughPoints =
        dataService.totalPoints() >= reward().priceToUnlock;
      @let selectionButtonConfig = config().selectionButton.states.default;
      @let configWithAvailability =
        hasEnoughPoints
          ? selectionButtonConfig.pointsAvailable
          : selectionButtonConfig.pointsUnavailable;

      @let tpl =
        configWithAvailability.template
          | replaceVars: reward().priceToUnlock
          | safe;
      <button
        type="button"
        [title]="tpl"
        [innerHTML]="tpl"
        (click)="onSelectReward()"
        class="btn selection-button"
        [style.color]="configWithAvailability.color"
        [style.border]="configWithAvailability.border"
        [style.fontFamily]="selectionButtonConfig.fontFamily"
        [style.backgroundColor]="selectionButtonConfig.backgroundColor"
        [style.borderRadius]="config().selectionButton.states.borderRadius"
      ></button>
    }
  </div>
</div>
